import { useEffect } from "react";
import styles from "./EnvironmentItem.module.scss";
import { DropDownIcon } from "../../../../../../assets/svg/DropDownIcon";
import { DropDown } from "../../../../../../shared/DropDown/DropDown";
import { EnvironmentOption } from "./EnvironmentOptions/EnvironmentOptions";
import { useURLRouting } from "../../../../../../utils/hooks/useURLRouting";

import { EnvironmentService } from "../../../../../../services/EnvironmentService";
import { useAppDispatch } from "../../../../../../redux/store";
import { getProjectStagesThunk } from "../../../../../../redux/reducers/ui/uiThunks";
import {
  setActiveEnvironmentId,
  setCurrentEnvironment,
  setEnvironmentActiveValue,
} from "../../../../../../redux/reducers/ui/uiReducer";
import { getPlayCanvasStringValue } from "../../../../../../utils/functions/getPlayCanvasStringValue";

export const EnvironmentItem = () => {
  const dispatch = useAppDispatch();
  const { currentView, setItem } = useURLRouting();
  const { list_id } = currentView;
  // Make sure - numeric and finite.
  const parsedId = typeof list_id === "string" ? list_id.trim() : "";
  const stageId = /^\d+$/.test(parsedId) ? parseInt(parsedId, 10) : null;
  const stageOptions = EnvironmentService.getAllAvailableStagesOptions();
  const windowPlay = (window as any)?.containerRef?.current?.contentWindow
    ?.VividMaterialAPI;

  useEffect(() => {
    const objects = windowPlay?.findAllChangers();
    const stageOptions = EnvironmentService.getAllAvailableStagesOptions();
    let allData: any[] = [];

    objects?.forEach((item: any, index: number) => {
      const existOption = stageOptions?.find(stage => {
        // Get all variants to find matching playcanvasString
        const variants = EnvironmentService.getAllProxyVariants(
          stage.proxyOptions
        );
        const nodeName = variants[0]?.playcanvasString
          ? getPlayCanvasStringValue(variants[0].playcanvasString)
          : null;
        return nodeName?.toLowerCase() === item.name.toLowerCase();
      });

      //get current playcanvas value for existing property
      if (existOption) {
        const currentOptionValue = windowPlay.getValueMaterail(
          item.name,
          existOption.proxyName
        );
        allData = [
          ...allData,
          {
            proxyName: existOption.proxyName,
            proxyValue: currentOptionValue.name,
          },
        ];
      }
    });

    dispatch(setEnvironmentActiveValue(allData));
  }, []);

  useEffect(() => {
    const setCurrentSceneValue = async () => {
      // Guard invalid or missing id from URL
      if (stageId == null) {
        console.warn("Invalid stageId in URL; navigating back to list");
        setItem("");
        return;
      }
      // Fetch the specific stage with all its options
      console.log("stageId After refreshing", stageId);
      const stage = await dispatch(getProjectStagesThunk(stageId)).unwrap();

      if (stage && stage.id) {
        // Check if stage has any options
        const hasGeometryOptions =
          stage.availableGeometryOptions &&
          stage.availableGeometryOptions.length > 0;
        const hasOptions =
          stage.availableOptions && stage.availableOptions.length > 0;

        // If no options available, redirect back to list
        if (!hasGeometryOptions && !hasOptions) {
          console.log(
            "No options available for this environment, redirecting back"
          );
          setItem("");
          return;
        }

        dispatch(setActiveEnvironmentId(stageId));
        dispatch(setCurrentEnvironment(stage));
      }
    };

    if (!stageOptions) {
      setCurrentSceneValue();
    } else {
      // If stageOptions is already loaded, check if it's empty
      if (!stageOptions || stageOptions.length === 0) {
        console.log("No options available (cached), redirecting back");
        setItem("");
      }
    }
  }, []);

  useEffect(() => {
    // This code set default value from existing properties
    if (stageOptions?.length) {
      stageOptions.forEach(stage => {
        const { proxyOptions, proxyName } = stage;
        const variants = EnvironmentService.getAllProxyVariants(proxyOptions);
        const nodeName = getPlayCanvasStringValue(
          variants[0]?.playcanvasString
        );
        const activeCanvasValue = windowPlay.getValueMaterail(
          nodeName,
          proxyName
        )?.name;
        const isVariantsHasOption = !!variants.find(
          variant => variant.name === activeCanvasValue
        );

        if (!isVariantsHasOption) {
          windowPlay.setValueName(nodeName, proxyName, variants[0].name);
        }
      });
    }
  }, [stageOptions, windowPlay]);

  const handleBack = () => {
    setItem("");
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <button onClick={handleBack}>
          <DropDownIcon /> Back
        </button>

        <div className={styles.text}>Configuration</div>

        <div className={styles.spacer}></div>
      </div>
      <div className={styles.content}>
        {stageOptions?.map((stage: any, idx) => {
          const { proxyName, proxyOptions } = stage;
          return (
            <DropDown defaultOpen={true} key={idx} title={`${proxyName}`}>
              <EnvironmentOption
                optionList={EnvironmentService.getAllProxyVariants(
                  proxyOptions
                )}
                proxyName={proxyName}
                stage={stage}
              />
            </DropDown>
          );
        })}
        {/* <DropDown title="Time of day">
          <TimeSlider />
        </DropDown>
        <DropDown title="Altitude">
          <RangeSlider />
        </DropDown> */}
      </div>
    </div>
  );
};
